
module.exports = {
	status: 'ready',
	title: 'Youtube',
	notes: '',
	context: {
	},
};
